var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartStyleLinebreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28571 12.7143H8V5.85714H6.28571V12.7143ZM5.71429 5.28571H8.57143V13.2857H5.71429V5.28571ZM3.42857 0.714285V4.71428H5.14286V0.714285H3.42857ZM2.85714 0.142857H5.71429V5.28571H2.85714V0.142857ZM0.571429 9.85714H2.28571V5.85714H0.571429V9.85714ZM0 5.28571H2.85714V10.4286H0V5.28571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartStyleLinebreak);
export default __webpack_public_path__ + "static/media/chart-style-linebreak.28437404814024ff0fa1036dd2f88368.svg";
export { ForwardRef as ReactComponent };